import React, { Component } from "react";
import brandLogo from "../../images/login/Logo.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import history from "../history";
import { config } from "../../constants";
import CircleSign from "../ui/CircleSign";
import AppConfig from "../../config";
import Help from "../../images/common/help.png";
import RequestAssistance from "../ui/RequestAssistance";
import ForgotPass from "../ui/ForgotPass";
import { Form } from "react-bootstrap";
import { Eye, EyeSlash } from 'react-bootstrap-icons';
import SetNewPass from "../ui/SetNewPass";
import jwt_decode from "jwt-decode";
import ConfirmationModal from "../ui/ConfirmationModal";
import AuthService  from "../../utils/authService";

const appName = "/ArchicubedWeb";
const adminPage = "/ArchicubedWeb/admin";
const signInPage = "/ArchicubedWeb/sign-in";
const url = config.url.URL;

export default class SignIn extends Component {
  state = {
    showSignInDetails: "none",
    btnexternaluserclicked: false,
    showRequestAssistanceModal: false,
    showReqAssistConfirmationModal: false,
    showForgotPassModal: false,
    showForgetPassConfirmationModal: false,
    showPassword: false,
    password: '',
    emailVal: true,
    passVal: true
  };

  showPass = React.createRef();
  
  componentDidMount() {
    const loginError = sessionStorage.getItem("loginError");
    if (loginError) {
      toast.error(loginError);
      sessionStorage.removeItem("loginError");
    }
  }
/*
  componentDidMount() {
    const SAML = require("saml-encoder-decoder-js");
    const zlib = require("react-zlib-js");
    var XMLParser = require("react-xml-parser");
    const convert = require("xml-js");

    const queryParams = new URLSearchParams(window.location.search);
    const l_response = queryParams.get("SAMLResponse");
    const l_signature = queryParams.get("Signature");
    const token = queryParams.get("your SAML encoded token");

    document.addEventListener('keypress', this.handle);


    if (l_response != null) {
      SAML.decodeSamlPost(l_response, function (err, xml) {
        if (err) {
          throw new Error(err);
        }
        
        var uriDecoded = decodeURIComponent(l_response);

        console.log("uriDecoded is : " + uriDecoded);
        let base64ToString = Buffer.from(uriDecoded, "base64");

        console.log("base64ToString is : " + base64ToString);

        var decodedSAML = zlib.inflateRawSync(base64ToString).toString();
        console.log("decodeSAML is : " + decodedSAML);

        var xml_parsed = new XMLParser().parseFromString(decodedSAML); // Assume xmlText contains the example XML
        var l_saml_response_status =
          xml_parsed.getElementsByTagName("samlp:StatusCode")[0].attributes
            .Value;
        var l_saml_response_email =
          xml_parsed.getElementsByTagName("AttributeValue")[0].value;

        if (l_saml_response_status.toString().toLowerCase().indexOf("status:success") > -1) 
        {
          
          let userInfo = {
            username: l_saml_response_email,
            password: l_saml_response_status,
          };

        fetch(`${url}/login`, {
            method: "POST",
            headers: {
              "content-type": "application/json",
              accept: "application/json",
            },
            body: JSON.stringify(userInfo),
          }).then((response) => {
            if (response.status === 401 || response.status === 404) {
              toast.error("Your credentials are incorrect. Please try again or contact your support.");
            } 
            else 
            {
              response.json().then(({ token }) => {
                localStorage.setItem("token", token);
                localStorage.setItem("authType", "AD");
                history.push("/signinprofile");
              });
            }
          });
        }
      });
    }
      
  }
*/
  componentWillUnmount() {
    document.removeEventListener('keypress', this.handle);
  }

  handleButtonClick = () => {
    if (this.showPass.current) {
      this.showPass.current.openChangePasswordModal();
    }
  };

  openCloseRequestAssistanceModal = () => {
    //this.setState({showRequestAssistanceModal: !this.state.showRequestAssistanceModal});
    if (this.state.showRequestAssistanceModal)
      this.setState({ showReqAssistConfirmationModal: true });
    else
      this.setState({showRequestAssistanceModal: true});
  };

  successedRequestAssistanceModal = () => {
    this.setState({showRequestAssistanceModal: false});
  }

  closeConfirmationReqAssistModal = ()=>{
    this.setState({ showReqAssistConfirmationModal: false });
  }

  doubleCloseReqAssistModals = ()=> {
    this.setState({
      showRequestAssistanceModal: false,
      showReqAssistConfirmationModal: false,
    });
  }

  openCloseForgotPassModal = () => {
    //this.setState({showForgotPassModal: !this.state.showForgotPassModal});
    if (this.state.showForgotPassModal)
      this.setState({showForgetPassConfirmationModal: true });
    else
      this.setState({showForgotPassModal: true});
  };

  successedForgetPassModal = () => {
    this.setState({showForgotPassModal: false});
  }

  closeConfirmationForgetPassModal = ()=>{
    this.setState({ showForgetPassConfirmationModal: false });
  }

  doubleCloseForgetPassModals = ()=> {
    this.setState({
      showForgotPassModal: false,
      showForgetPassConfirmationModal: false,
    });
  }

  SignSSOClick = () => {
  const auth = new AuthService();
  auth.signinRedirect()
  };
s
  togglePasswordVisibility = () => {
    this.setState({showPassword: !this.state.showPassword});
  };


  SignInClick = async () => {

    if (this.refs.email.value.trim() == "") {
      this.setState({ emailVal: false })
    } else {
      this.setState({ emailVal: true })
    }
    if (this.refs.password.value.trim() == "") {
      this.setState({ passVal: false })
    } else {
      this.setState({ passVal: true })
    }

    if (this.refs.email.value.trim() == "" || this.refs.password.value.trim() == "") {
      toast.error("Your credentials are incorrect. Please try again or contact your support.");
      return;
    }

    let userInfo = {
      username: this.refs.email.value,
      password: this.refs.password.value,
    };

    try {
      const response = await fetch(`${url}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(userInfo),
      });

      if (!response.ok) {
        const errorData = await response.json();
        switch (errorData.errorCode) {
          
          case "INVALID_CREDENTIALS":
            toast.error(
              "Your credentials are incorrect. Please try again or contact support."
            );
            break;
          case "USER_NOT_FOUND":
          case "USER_INACTIVE":
            toast.error("Account does not exist. Please contact your support.");
            break;
          default:
            toast.error(
              "An unknown error occurred. Please try again or contact support."
            );
        }
        return;
      }

      const { token } = await response.json();
      localStorage.setItem("token", token);
      localStorage.setItem("authType", "AD");
      localStorage.setItem("email", userInfo.username);

      const tokenDecoded = jwt_decode(token);
      const expiryDate = new Date(tokenDecoded.PasswordExpiry);
      const nowDate = new Date();

      if (expiryDate < nowDate) {
        this.showPass.current.openChangePasswordModal();
      } else {
        toast.success("Successful Login");

        const unblock = history.block();
        unblock();

        setTimeout(() => {
          history.push("/signinprofile");
        }, 1000);
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("A network error occurred. Please try again later.");
    }
  }

  ToggleSignIn = () => {
    this.setState({
      showSignInDetails:
        this.state.showSignInDetails == "block" ? "none" : "block",
      btnexternaluserclicked:
        this.state.btnexternaluserclicked == false ? true : false,
    });
  };


  passwordHandler = (e)=> {
    this.setState({password: e.target.value})
  };

  handle = (e) =>{
    if(this.state.showSignInDetails == 'block' && e.charCode === 13){
        e.preventDefault(); // Ensure it is only this code that runs
        this.SignInClick();
    }
  }

  styles = {
    display: this.state.showSignInDetails,
  };

  render() {
    return (
      <div>
        <div>
          <img src={brandLogo}></img>
        </div>
        <div className="form-group">
          <button
            className="btn btn-primary btn-dark-blue"
            id="btn_brand_user"
            onClick={this.SignSSOClick}
          >
            Sign in as {AppConfig.brandName} user
          </button>
        </div>
        <div uid="wapV59" className="separator">
          If you are an External User
        </div>

        <div
          className="div-sign-in-details"
          style={{ display: this.state.showSignInDetails }}
        >
          <Form.Group className="form-group">
          <Form.Label className={`${this.state.emailVal ? "normal-title" : "validation-title"} margin-bot-1`}>Email <CircleSign /></Form.Label>
          <Form.Control
            id="email"
            name="email"
            className={`${this.state.emailVal ? "form-control" : "validation-control"}`}
            type="text" 
            ref="email" 
            placeholder="Email" 
            autoComplete="current-username" 
            //onKeyPress={(e)=>this.handle(e)} 
            required/>
          {!this.state.emailVal && <p className="p-required" style={{marginBottom:'0'}}>Required</p>}
          </Form.Group>

          <Form.Group className="form-group">
          <Form.Label className={`${this.state.passVal ? "normal-title" : "validation-title"} margin-bot-1`}>Password <CircleSign /></Form.Label>
            <div style={{ display: "flex", position: "relative" }}>
              <Form.Control
                id="password"
              name="password"
                type={this.state.showPassword ? "text" : "password"}
                className={`${this.state.passVal ? "form-control" : "validation-control"}`}
                value={this.state.password}
                ref="password"
                autoComplete="current-password"
                onChange={(e) => this.passwordHandler(e)}
                required="required"
                placeholder="Password"
                //onKeyPress={(e)=>this.handle(e)}
              />
              
              <div className="eye-pos">
                {this.state.showPassword ? (
                  <EyeSlash fill="blue" onClick={this.togglePasswordVisibility} />
                ) : (
                  <Eye fill="blue" onClick={this.togglePasswordVisibility} />
                )}
              </div>
            </div>
            {!this.state.passVal && <p className="p-required" style={{marginBottom:'0'}}>Required</p>}
          </Form.Group>

          <p className="forgot-password text-right">
            <a onClick={() => this.openCloseForgotPassModal()}>Forgot Password ?</a>

          </p>
          <div className="form-group" style={{marginBottom:"-10px"}}>
            <button
              className="btn btn-primary btn-light-blue btn-signin-external"
              onClick={this.SignInClick}
            >
              Sign In
            </button>
          </div>
        </div>

        <div className="form-group assistance-pos">
          <button
            className="btn btn-primary btn-light-blue"
            id="btn_external_user"
            style={{
              display: this.state.btnexternaluserclicked ? "none" : "block",
            }}
            onClick={this.ToggleSignIn}
          >
            Sign in as external user
          </button>
  

          <img  onClick={() => this.openCloseRequestAssistanceModal()} className="assistance-icon" src={Help}></img>
        </div>
        {this.state.showRequestAssistanceModal && (
        <RequestAssistance 
          openCloseRequestAssistanceModal={this.openCloseRequestAssistanceModal} 
          successed={this.successedRequestAssistanceModal} 
          showRequestAssistanceModal={this.state.showRequestAssistanceModal}
          />
        )}
        <ConfirmationModal 
          show={this.state.showReqAssistConfirmationModal} 
          hide={this.closeConfirmationReqAssistModal} 
          doubleCloseModals={this.doubleCloseReqAssistModals} 
          msg="Are you sure you want to leave this page ?"
          />
        <ForgotPass 
          openCloseForgotPassModal={this.openCloseForgotPassModal} 
          showForgotPassModal={this.state.showForgotPassModal}
          successed={this.successedForgetPassModal}
          />
        <SetNewPass ref={this.showPass} isLogin={true} msgContaint="Your password has been initialised or reset or it has expired. Please set a new personal password:"/>
        <ConfirmationModal 
          show={this.state.showForgetPassConfirmationModal} 
          hide={this.closeConfirmationForgetPassModal} 
          doubleCloseModals={this.doubleCloseForgetPassModals} 
          msg="Are you sure you want to leave this page ?" />

        <ToastContainer
          className="login-toast"
          position="bottom-right"
          style={{ marginBottom: "30px" }}
        />
      </div>
    );
  }
}